import { useMutation } from "@tanstack/react-query";

import { ILimit } from "../../limit/types";
import { coolingAPI } from "../coolingAPI";
import { LIMIT_QUERY_KEY } from "../../limit";
import { queryClient } from "../../queryClient";

export const useRefuseLoanMutation = () => {
  return useMutation ({
    mutationKey: ["refuse-loan"],
    mutationFn: () => coolingAPI.refuseLoan(),
    onSuccess: () => {
      queryClient.setQueryData<ILimit>([LIMIT_QUERY_KEY], (old) => {
        if (!old) return old;

        return { ...old, status: "CLOSED" as const };
      });
    },
  });
};
